import { ArpMedia } from '@arpeggi/shared'
import { FC, useState } from 'react'
import { IconButton } from '../../core/Components'
import { DotsVertical, LinkIcon } from '../../core/icons'
import { Check, Details, Share, User } from '../../core/icons/responsive-icons'
import { InternalEndpoint } from '../../Internal'
import * as Dropdown from '../../platform/new-explore/components/Dropdown'
import { IconWrapper } from '../../platform/new-explore/components/TableRow'

interface Props {
  arpMedia: ArpMedia
}

export const ActionsDropdown: FC<Props> = ({ arpMedia }) => {
  const [copied, setCopied] = useState(false)

  return (
    <Dropdown.Root
      onOpenChange={(open) => {
        if (open === false) {
          setCopied(false)
        }
      }}
    >
      <Dropdown.Trigger asChild>
        <IconButton>
          <DotsVertical />
        </IconButton>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content side="bottom" sideOffset={4}>
          <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation()
              window.open(`/${InternalEndpoint}/arp/${arpMedia.id}`, '_blank')
            }}
          >
            <IconWrapper>
              <LinkIcon />
            </IconWrapper>
            Open internal view
          </Dropdown.Item>
          <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation()
              window.open(`/${arpMedia.type}?token=${arpMedia.id}`, '_blank')
            }}
          >
            <IconWrapper>
              <Details />
            </IconWrapper>
            {`Open ${arpMedia.type} details`}
          </Dropdown.Item>
          <Dropdown.Item
            onClick={(e) => {
              e.stopPropagation()
              window.open(`/profile/${arpMedia.user.walletAddress}`, '_blank')
            }}
          >
            <IconWrapper>
              <User />
            </IconWrapper>
            View artist profile
          </Dropdown.Item>
          <Dropdown.Item
            onClick={(e) => {
              e.preventDefault()
              navigator.clipboard.writeText(
                `${location.origin}/${arpMedia.type}?token=${arpMedia.id}`
              )
              setCopied(true)
            }}
          >
            <IconWrapper>{copied ? <Check /> : <Share />}</IconWrapper>
            {copied ? 'Copied to clipboard' : 'Share'}
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  )
}
